import React, {useState} from 'react';
import { Tooltip, Typography, Fab, Dialog, DialogTitle, Grid, Card, CardContent } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import { DataProvider, useDataSetters, useDataState } from '../../../DataContext';
import TimeSeriesCard from './TimeSeriesCard';

import {transformData} from './TransformData'

const SeasonalStatsDashboard = () => {

    // App state management; see DataContext.js
    const {
        vineyardSummaryData,
        userGroup,
    } = useDataState();

    const {
        setVineyardSummaryData,
        setUserGroup,
    } = useDataSetters();

   const [seasonalDashboardOpen, setSeasonalDashboardOpen] = useState(false);

   const transformedData = transformData(vineyardSummaryData);

    const handleDashboardOpen = () => {
        setSeasonalDashboardOpen(true);
    };
    
    const handleDashboardClose = () => {
        setSeasonalDashboardOpen(false);
    };

    // Define plant and fruit metrics here
    const plantMetrics = [
        'canopy_volume_index_0d',
        'shoot_height_avg',
        'trunk_thickness_inches'
    ];

    const fruitMetrics = [
        'yield_index',
        'cluster_areas_avg',
        'cluster_count', 
        'percent_veraison'
    ];
  
    const renderMetricCards = (keys, title) => (
        <Card elevation={3} style={{ borderRadius: '15px', marginBottom: '20px' }}>
          <CardContent>
            <Typography align="center" variant="h5" style={{ marginBottom: '20px' }}>
              {title}
            </Typography>
            <Grid container spacing={3}>
              {keys
                .filter((key) => transformedData.hasOwnProperty(key))
                .map((key) => (
                  <Grid item xs={3} key={key}>
                    <TimeSeriesCard id={key} dataSeries={transformedData[key]} />
                  </Grid>
                ))}
            </Grid>
          </CardContent>
        </Card>
      );

    return (
        <div>
            <Tooltip title={<Typography sx={{ fontSize: 14 }}>Seasonal Summary Viewer</Typography>}>
                <Fab
                    color="primary"
                    aria-label="timeseries-summary-viewer"
                    onClick={handleDashboardOpen}
                    style={{ position: 'fixed', top: '350px', right: '10px' }}
                >
                    <InsightsIcon />
                </Fab>
            </Tooltip>
            <Dialog open={seasonalDashboardOpen} onClose={handleDashboardClose} fullWidth maxWidth="xlg">
                <div style={{ padding: '30px' }}>
                {renderMetricCards(plantMetrics, 'Plant Metrics')}
                {renderMetricCards(fruitMetrics, 'Fruit Metrics')}
                </div>
            </Dialog>
        </div>
    );
};

export default SeasonalStatsDashboard;

